export default {
    bind(el, binding) {
        if (typeof binding.value !== 'function') {
            throw '长按回调必须为函数';
        }
        let pressTimer = null;

        // 启动长按计时器
        const start = (e) => {
            if (e.type === 'click' && e.button !== 0) return;
            pressTimer = setTimeout(() => binding.value(e), 1000); // 时间阈值设为1秒
        };

        // 取消长按
        const cancel = () => {
            clearTimeout(pressTimer);
            pressTimer = null;
        };

        // 绑定事件
        el.addEventListener('mousedown', start,{passive:true});
        el.addEventListener('touchstart', start,{passive:true});
        el.addEventListener('mouseup', cancel,{passive:true});
        el.addEventListener('touchend', cancel,{passive:true});
        el.addEventListener('mouseleave', cancel,{passive:true});
        el.addEventListener('touchcancel', cancel,{passive:true});
    }
};


